import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget
    const text = this.sourceTarget.innerText
    navigator.clipboard.writeText(text)
    // ux feedback
    button.innerText = "Copied"
    setTimeout(() => (button.innerText = "Copy"), 1500)
  }
}
